import { TextField } from '@mui/material';
import { t } from 'i18next';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../shared/redux/store';

const RequestComment = () => {
  const request = useSelector((state: RootState) => state.requestSearch.searchRequest.equivalencies);
  return (
    <TextField
      fullWidth
      tabIndex={-1}
      id='observation-input'
      data-testid={'observation-input'}
      label={<>{t('Observation')}</>}
      value={request?.observation || 'Sin comentarios'}
      disabled
    />
  );
};

export default RequestComment;
